import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { NativeService } from '@core/services/native/native.service';
import { ModalStoreSelector } from '@common/selectors/modal.selector';
import { ModalScrollBlockBase } from '@core/base/modalScrollBlock/modal-scroll-block.base';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ModalConfig, GetModalInterface } from '@core/services/modals/modals-util.type';
import { ModalsService } from '@core/services/modals/modals.service';

export type ConfirmModalConfig = ModalConfig<{
  handle: 'confirm-modal';
  inputs: ConfirmModalInputs;
  outputs: {
    type: 'confirm' | 'cancel';
  };
}>;
type ConfirmModalInputs = {
  backgroundColor?: IContentBuilderFieldColor;
  textColor?: IContentBuilderFieldColor;
  buttonBackgroundColor?: IContentBuilderFieldColor;
  buttonTextColor?: IContentBuilderFieldColor;
  title?: string;
  message?: string;
  confirmButtonText: string;
};
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  standalone: false,
})
export class ConfirmModalComponent
  extends ModalScrollBlockBase
  implements OnInit, GetModalInterface<ConfirmModalConfig>
{
  static handle = 'confirm-modal' as const;

  @Input() backgroundColor: IContentBuilderFieldColor = {
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  };

  @Input() textColor: IContentBuilderFieldColor = {
    value: 'neutral-800',
    type: ColorFieldTypesValues.Palette,
  };

  @Input() buttonBackgroundColor: ConfirmModalInputs['buttonBackgroundColor'] = undefined;

  @Input() buttonTextColor: ConfirmModalInputs['buttonTextColor'] = undefined;

  @Input() title: ConfirmModalInputs['title'] = undefined;
  @Input() message: ConfirmModalInputs['message'] = undefined;
  @Input() confirmButtonText!: ConfirmModalInputs['confirmButtonText'];

  index$: Observable<number> = this.modalSelector
    .selectModal(ConfirmModalComponent.handle)
    .pipe(map(el => (el?.index ? el.index : 4)));

  isNotched = false;

  isLoading = false;

  constructor(
    private modalSelector: ModalStoreSelector,
    private readonly modalsService: ModalsService<ConfirmModalConfig>,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.isNotched = await NativeService.isNotched();
  }

  close(): void {
    this.modalsService.close(ConfirmModalComponent.handle);
    this.modalsService.emitEvent({
      data: { type: 'cancel' },
      handle: ConfirmModalComponent.handle,
    });
  }

  submit(): void {
    this.isLoading = true;
    this.modalsService.emitEvent({
      data: { type: 'confirm' },
      handle: ConfirmModalComponent.handle,
    });
  }
}
